'use client';

import React from 'react';
import { EventRecord } from './mockEvents';
import EventCard from './EventCard';
import EventListRow from './EventListRow';
import { CalendarDays } from 'lucide-react';

interface Props {
  events: EventRecord[];
  viewMode: 'grid' | 'list';
}

export default function EventsGrid({ events, viewMode }: Props) {
  if (events.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center mt-6">
        <div className="w-12 h-12 rounded-xl bg-muted flex items-center justify-center mb-4">
          <CalendarDays size={22} className="text-muted-foreground" strokeWidth={1.5} />
        </div>
        <p className="text-sm font-semibold text-foreground">No events match your filters</p>
        <p className="text-xs text-muted-foreground mt-1 max-w-xs">
          Try changing the status filter or create a new event to get started.
        </p>
        <button className="mt-4 btn-primary text-xs">
          Create Your First Event
        </button>
      </div>
    );
  }

  if (viewMode === 'list') {
    return (
      <div className="mt-6 bg-white rounded-xl border border-border shadow-card overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border bg-muted/40">
              <th className="table-th">Event</th>
              <th className="table-th">Type</th>
              <th className="table-th">Dates</th>
              <th className="table-th">Location</th>
              <th className="table-th">Status</th>
              <th className="table-th">Contacts</th>
              <th className="table-th">Pipeline</th>
              <th className="table-th">Meetings</th>
              <th className="table-th">Countdown</th>
              <th className="table-th text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {events.map((ev) => (
              <EventListRow key={ev.id} event={ev} />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-5">
      {events.map((ev) => (
        <EventCard key={ev.id} event={ev} />
      ))}
    </div>
  );
}